import {
  converge,
  groupBy,
  map,
  multiply,
  pipe,
  prop,
  propOr,
  pick,
  sortBy,
  toPairs,
} from 'ramda'

/**
 * Common fields that are found in all pharmacies. These fields are used to
 * group pharmacies by name.
 *
 * @type {string[]}
 */
const commonPharmacyFields = [
  'uuid',
  'chainCode',
  'name',
  'pharmacyRate',
  'priceFairness',
  'image',
  'sidecarCost',
  'memberPays',
  'nonFacilityCostAfterSidecar',
  'costPlusUrl',
  'mailOrder',
  'shipping',
  'careEstimateResult',
  'ndc',
]

/**
 * Parses the pharmacy list into a list of pharmacies grouped by name.
 *
 * @param {Array} pharmacies - The list of pharmacies to parse.
 * @returns {Array} The list of pharmacies grouped by name.
 */
export const parsePharmacyList = pipe(
  // groups all the doctors by their name field
  groupBy(prop('name')),
  // sort the doctors by cheap and close first
  map(
    sortBy(
      converge(multiply, [propOr(1, 'distance'), propOr(1, 'pharmacyRate')]),
    ),
  ),
  // turns the sorted map into tuples [name, pharmacies]
  toPairs,
  // pulls out the common fields from each pharmacy and
  // includes it at the group root, then puts all the
  // pharmacies into a locations array.
  map(([__, pharmacies]) => ({
    ...pick(commonPharmacyFields, pharmacies[0]),
    locations: pharmacies,
  })),
)
